import { withNavBar } from "../../shared/NavBar/NavBar"; 
import sharedHistory from "../../../shared/History";
import { RouteNames } from "../../../shared/enums/RouteNames";
import Localization from "../../../shared/Localization";
import i18n from "i18n-js";
import { useEffect, useState } from "react";
import "./CreateAccountSuccess.scss";

const CreateAccountSuccess = () => {
  const doneClicked = () => {
    sharedHistory.push(RouteNames.AccountVerification);
  };

  const [local, setLocal] = useState<typeof i18n | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      const newLocal = await Localization("en");
      setLocal(newLocal);
    };

    fetchData();
  }, []);

  if (!local) return <></>;

  const pageText: string[] = 
    local.t("createAccountSuccessPage.text") as any
  ;

  return (
    <>
      <h4 className="main_title" data-testid="mainTitle">
        {local.t("createAccountSuccessPage.title")}
      </h4>
      <div className="row">
        <div className="col m9 s12">
          <h3 className="center valign-wrapper">
            <i className="medium material-icons success">check</i> 
            {local.t("createAccountSuccessPage.subTitle")}
          </h3>
        </div>
        <div className="col m3 s12">
          <button
            className="btn btn-primary"
            data-testid="doneButton"
            onClick={doneClicked}
          >
            {local.t("createAccountSuccessPage.doneButtonText")}
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col s12 font-weight-bold">
          {pageText[0]}
        </div>
      </div>
      <div className="row">
        <div className="col s12">
          {pageText[1]}
        </div>
      </div>
      <div className="row">
        <div className="col s12">
          {pageText[2]}
        </div>
      </div>
    </>
  );
}; 

export default withNavBar(CreateAccountSuccess);
